import { render, staticRenderFns } from "./index5.vue?vue&type=template&id=3fb52f1c&scoped=true&"
import script from "./index5.vue?vue&type=script&lang=js&"
export * from "./index5.vue?vue&type=script&lang=js&"
import style0 from "./index5.vue?vue&type=style&index=0&id=3fb52f1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb52f1c",
  null
  
)

export default component.exports